/**
 * Address edit section for the venue page Details tab. Reads as a record and
 * edits in place.
 */
import { AddressEditForm, type AddressDraft } from './AddressEditForm';
import { EditSection } from './EditSection';
import { ReadGrid } from './ReadGrid';
import { nullable, type SectionProps } from './section-props';
import { useFormDraft } from './use-form-draft';

export function AddressSection({ venue, readOnly, save }: SectionProps) {
  const seed: AddressDraft = {
    addressLine1: venue.addressLine1,
    addressLine2: venue.addressLine2 ?? '',
    city: venue.city,
    state: venue.state,
    zipCode: venue.zipCode,
    country: venue.country,
  };
  const { draft, setField, setDraft, reset } = useFormDraft(seed, venue.updatedAt);

  return (
    <EditSection
      title="Address"
      readOnly={readOnly}
      onCancel={reset}
      onSave={() =>
        save({
          addressLine1: draft.addressLine1.trim(),
          addressLine2: nullable(draft.addressLine2),
          city: draft.city.trim(),
          state: draft.state,
          zipCode: draft.zipCode.trim(),
          country: draft.country.trim(),
        })
      }
      view={
        <ReadGrid
          rows={[
            { label: 'Street', value: venue.addressLine1 },
            { label: 'Line 2', value: venue.addressLine2 },
            { label: 'City', value: venue.city },
            { label: 'State', value: venue.state },
            { label: 'ZIP', value: venue.zipCode, mono: true },
            { label: 'Country', value: venue.country },
          ]}
        />
      }
      form={<AddressEditForm draft={draft} setField={setField} setDraft={setDraft} />}
    />
  );
}
